import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import { Menu, MenuItem } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';

import { ComposedActions } from '../../helpers/actions';
import { IMenuItem } from './CatizMenu';
import { activeMenuColor, blue, fontColor } from './Colors';

const StyledButton = withStyles({
  root: {
    color: `${fontColor}`,
    fontSize: '12px',
  },
})(Button);

const StyledMenu = withStyles({
  paper: {
    background: `${blue}`,
    color: `${fontColor}`,
    fontSize: `12px`,
  },
  list: {
    '&> li': {
      fontSize: '16px',
      paddingRight: '0px',
      paddingLeft: '0px',
      '&:hover': {
        background: `${activeMenuColor}`,
      },
    },
  },
})(Menu);

const ItemContainer = styled.span<any>`
  display: flex;
  align-items: center;
  padding-right: 12px;
  padding-left: 12px;
  width: 100%;
  justify-content: space-between;
  background: ${(props) =>
    props.activeSubMenu ? `${activeMenuColor}` : 'inherit'};
`;

export default function SubMenu({
  menuItem,
  closeParent,
}: {
  menuItem: IMenuItem;
  closeParent: () => void;
}) {
  const [open, setOpen] = React.useState(false);
  const subMenuRef = useRef(null);
  const dispatch = useDispatch();
  const handleClose = (event: React.MouseEvent<EventTarget>) => {
    setOpen(false);
  };

  const onMenuItemClick = (evt: React.MouseEvent<EventTarget>) => {
    if (menuItem.children) {
      setOpen(true);
    } else {
      closeParent();
      dispatch(
        ComposedActions.PushCatizMenuItem.aCreator({
          menuItemId: menuItem.id,
        })
      );
    }
  };

  return (
    <>
      <ItemContainer
        activeSubMenu={open}
        onClick={onMenuItemClick}
        ref={subMenuRef}
        data-item="submenu"
        id={menuItem.id}
      >
        {menuItem?.label}
        {menuItem!.children && menuItem?.children?.length > 0 && (
          <ArrowRightIcon />
        )}
      </ItemContainer>
      {menuItem!.children && menuItem?.children?.length > 0 && (
        <>
          <StyledMenu
            id="simple-menu"
            anchorEl={() => (subMenuRef.current as any)?.parentElement}
            getContentAnchorEl={null}
            keepMounted
            open={open}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          >
            {menuItem?.children?.map((subMenuItem) => {
              return (
                <MenuItem key={subMenuItem.label}>
                  <SubMenu
                    menuItem={subMenuItem}
                    closeParent={() => {
                      setOpen(false);
                      closeParent();
                    }}
                  />
                </MenuItem>
              );
            })}
          </StyledMenu>
        </>
      )}
    </>
  );
}
